// Module
var code = "<course-selection></course-selection>";
// Exports
module.exports = code;